// ============================================================================
// Public constants (backend endpoints, etc.)
// ============================================================================
//
// Note: Uses an env override when available so you can point to a local or
// staged backend without code changes.

export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL ?? 'https://api.vyva.io';

